import type { DefaultIconProps } from '../../../utils';
import { DefaultIconWrapper, getSemanticTextColor } from '../../../utils';

export const DownloadIcon = ({
  color = 'white',
  width = 10,
  marginLeft,
  marginRight,
  containerSize,
}: DefaultIconProps) => (
  <DefaultIconWrapper marginLeft={marginLeft} marginRight={marginRight} containerSize={containerSize} width={width}>
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 10 11">
      <path
        fill={getSemanticTextColor(color)}
        fillRule="evenodd"
        d="M9.198 9.45c.414 0 .75.336.75.75s-.336.75-.75.75H.75c-.414 0-.75-.336-.75-.75s.336-.75.75-.75zM4.974 0c.69 0 1.25.56 1.25 1.25v2.716h1.71c.31 0 .589.19.7.479.111.29.034.617-.196.826l-2.96 2.686c-.143.13-.322.194-.503.194s-.361-.064-.504-.194L1.509 5.271c-.228-.208-.307-.536-.194-.826.11-.289.389-.479.699-.479h1.71V1.25c0-.69.56-1.25 1.25-1.25z"
      />
    </svg>
  </DefaultIconWrapper>
);
